import api from "../services";

const getEmployeeList = api.injectEndpoints({
    endpoints : (builder) => ({
        getDropdownUsers : builder.query({
            query : () => ("/api/dropdown/users"),
            transformResponse: (response) => response.data,
        })
    })
})

export default getEmployeeList;
export const { useGetDropdownUsersQuery } = getEmployeeList;